import { FemaleIcon } from "@/assets/images/svgIcons/femaleIcon"
import { MaleIcon } from "@/assets/images/svgIcons/maleIcon"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { GenderCategory } from "@/modules/profile/publicProfile/gateway/publicProfileDto"
import { Text } from "@/components/ui/baseUi/text"

type GenderInputProps = {
  selectedGender: GenderCategory
  handleSelectGender: (gender: GenderCategory) => void
} & React.HTMLAttributes<HTMLDivElement>

export function GenderInput({ handleSelectGender, selectedGender, className, ...props }: GenderInputProps) {
  return (
    <div className={cn("flex justify-center", className)} {...props}>
      <div
        onClick={() => handleSelectGender(GenderCategory.FEMALE)}
        className={cn(
          "text-primary mr-2 flex h-45 w-33 cursor-pointer items-center justify-center rounded-lg bg-neutral-200 transition-all duration-300",
          "hover:bg-primary-400",
          {
            "bg-primary-500": selectedGender === GenderCategory.FEMALE,
          },
        )}
      >
        <div className="flex flex-col items-center justify-center gap-2 text-textDefault-caption">
          <FemaleIcon color="currentColor" />
          <Text>{word("scoreboard.filters.female")}</Text>
        </div>
      </div>
      <div
        onClick={() => handleSelectGender(GenderCategory.MALE)}
        className={cn(
          "text-primary ml-2 flex h-45 w-33 cursor-pointer items-center justify-center rounded-lg bg-neutral-200 transition-all duration-300",
          "hover:bg-primary-400",
          {
            "bg-primary-500": selectedGender === GenderCategory.MALE,
          },
        )}
      >
        <div className="flex flex-col items-center justify-center gap-2 text-textDefault-caption">
          <MaleIcon className="mt-2" color="currentColor" />
          <Text>{word("scoreboard.filters.male")}</Text>
        </div>
      </div>
    </div>
  )
}
